import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { FloormapUiService } from '../../services/floormap-ui.service';

@Component({
    selector: 'kanzi-floormap-toolbar',
    templateUrl: './floormap-toolbar.component.html',
    styleUrls: ['./floormap-toolbar.component.scss'],
    standalone: false
})
export class FloormapToolbarComponent {
  @Input() editorMode: boolean = false;
  zoomValue: number = 100;
  layoutUpdated: Observable<boolean> = this.floormapUIService.updateLayout;
  
  constructor(private floormapUIService: FloormapUiService) {}

  ngOnInit(): void {}

  onZoomChange() {
    this.floormapUIService.zoom = this.zoomValue;
    this.floormapUIService.performOperation.next('ZOOM');
  }

  onExportToImage(event:any) {
    this.floormapUIService.performOperation.next('PNG');
  }

  onSaveLayout(event:any) {
    this.floormapUIService.updateLayout.next(false);
    this.floormapUIService.saveLayout.next('SAVE');
  }

  onDeleteItem(event:any) {
    this.floormapUIService.delete();
  }
}
